import React, {forwardRef} from 'react';
import {convertirModena, sumaCompensacion, sumaIngreso, sumaPrestacion} from "../../shared/utils/utils";
import "./style.scss"

export const TablaDetalleCompensacion = forwardRef(({fields}, ref) => {

    let compensacin = (fields.length > 0 ? fields[0]['compensacion'] : []);
    let prestacion = (fields.length > 0 ? fields[0]['prestacion'] : []);

    const sumaPrestaciones = sumaPrestacion(fields);

    const sumaCompensaciones = sumaCompensacion(fields);
    const ingreso = sumaIngreso(fields)
    const totales = [...sumaCompensaciones, ...sumaPrestaciones]


    return (
        <div className="tablaDetalleCompensacion" ref={ref}>

            <div style={{marginLeft: "80.8%"}} className={'hidden'}>
                <img alt={"toa"} src="/img/toa.png" style={{marginTop:"10px", height:"150px", width:"150px"}}/>
            </div>

            <table id="compensacion" className="items-center  mx-1 bg-transparent border-collapse px-3">
                <thead>
                <tr>
                    <th className="px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color">NOMBRE</th>
                    <th className="px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color">INGRESO</th>
                    {(fields.length > 0 && compensacin.length > 0) && compensacin.map(((data, i) => <th
                        className="px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color "
                        key={i}>{data['descrip_abrev']}<span className="ml-1" style={{
                        fontSize: '.8em',
                        display: "block"
                    }}>{data['porcentaje']}%</span></th>))}
                    {(fields.length > 0 && prestacion.length > 0) && prestacion.map(((data, i) => <th
                        className="px-5  align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color "
                        key={i}>{data['descrip_abrev']}<span className="ml-1" style={{
                        fontSize: '.8em',
                        display: "block"
                    }}>{data['porcentaje']}%</span></th>))}
                </tr>
                </thead>
                <tbody className="pb-2">
                {fields.map((field, i) => {
                    return <tr key={i}>
                        <td className="px-4 align-middle  text-xs whitespace-nowrap p-4 text-left items-center">
                            <span className="ml-3 font-bold text-blueGray-600">{field.nombres} </span></td>
                        <td className="px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center">
                                        <span
                                            className="ml-3 font-bold text-blueGray-600">{convertirModena(field.sub_total)} </span>
                        </td>
                        {(field['compensacion'].length > 0 ) && field['compensacion'].map(((data, i) => <td
                            className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center"
                            key={i}><span
                            className="ml-4 font-bold text-blueGray-600">{convertirModena(data['valor_porcentaje'])} </span>
                        </td>))}
                        {(field['prestacion'].length > 0 ) && field['prestacion'].map(((data, i) => <td
                            className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left items-center"
                            key={i}><span
                            className="ml-4 font-bold text-blueGray-600">{convertirModena(data['valor_porcentaje'])} </span>
                        </td>))}
                    </tr>
                })}
                </tbody>
                <tfoot>
                    <tr>
                        <td className="px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color">TOTALES</td>
                        <td className="px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color">{convertirModena(ingreso)}</td>
                        {totales.length > 0 && totales.map(((data, i) => <td
                            className="px-5  align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color "
                            key={i}>{convertirModena(data[1])}
                        </td>))}
                    </tr>
                </tfoot>
            </table>
        </div>
    );
});


